import React from "react";
import MspContextProvider from "./MspContext";
import MspButton from "./MspButton";


export default function MspLogin(props){

    const {failCallBack} = props;

    return (
        <MspContextProvider>
            <MspButton failCallBack={failCallBack}/>
        </MspContextProvider>
    );

}